import {
  Box,
  Button,
  Chip,
  Divider,
  List,
  ListItem,
  Typography,
} from "@mui/material";

export const KOT_STATUS = {
  PREPARING: {
    id: 1,
    label: "Preparing",
    color: "#f59e0b",
  },
  READY: {
    id: 2,
    label: "Ready",
    color: "#22c55e",
  },
  CANCELLED: {
    id: 3,
    label: "Cancelled",
    color: "#ef4444",
  },
};

export default function KotHistoryList({ kots, onViewDetails }) {
  return (
    <List disablePadding>
      {kots.map((kot) => {
        const status = KOT_STATUS[kot.status];

        return (
          <Box key={kot.id} sx={{ px: 1.5, py: 0.75 }}>
            <ListItem
              disableGutters
              sx={{
                px: 2,
                py: 1.75,
                borderRadius: "10px",
                borderLeft: `5px solid ${status.color}`,
                backgroundColor: `${status.color}08`,
                display: "flex",
                alignItems: "flex-start",
                transition: "background-color 0.2s ease",
                "&:hover": {
                  backgroundColor: `${status.color}12`,
                },
              }}
            >
              {/* LEFT CONTENT */}
              <Box sx={{ flex: 1 }}>
                {/* Title row */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 0.5,
                  }}
                >
                  <Typography fontWeight={700}>KOT #{kot.kotNo}</Typography>

                  <Chip
                    label={status.label}
                    size="small"
                    sx={{
                      height: 20,
                      fontSize: "11px",
                      fontWeight: 600,
                      backgroundColor: status.color,
                      color: "#fff",
                    }}
                  />
                </Box>

                {/* Meta info */}
                <Typography variant="body2" sx={{ color: "#475569", mb: 0.25 }}>
                  Order #{kot.orderNo} • {kot.orderType}
                </Typography>

                <Typography variant="body2" sx={{ color: "#64748b" }}>
                  {kot.floor || "-"}
                </Typography>

                <Typography variant="caption" sx={{ color: "#94a3b8" }}>
                  {kot.completedAt}
                </Typography>
              </Box>

              {/* RIGHT ACTION */}
              <Box sx={{ ml: 2 }}>
                <Button
                  size="small"
                  variant="text"
                  sx={{
                    fontWeight: 600,
                    textTransform: "none",
                    color: "#2563eb",
                    px: 0,
                    "&:hover": {
                      backgroundColor: "transparent",
                      textDecoration: "underline",
                    },
                  }}
                  onClick={() => onViewDetails(kot)}
                >
                  View Details
                </Button>
              </Box>
            </ListItem>
          </Box>
        );
      })}
    </List>
  );
}
